<template><div><h1 id="op-liste-fremdwahrungen" tabindex="-1"><a class="header-anchor" href="#op-liste-fremdwahrungen"><span>OP-Liste Fremdwährungen</span></a></h1>
<p>OP-Liste Fremdwährungen — Liste aus allen Offenen Posten in Fremdwährungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste aus allen OP die Fremdwährung enthalten. Jede Buchung wird auch in der Landeswährung (CHF) umgerechnet mit dem entsprechenden Kurs angezeigt. Die Liste wird nach Personen-ID und anschliessend nach Datum sortiert. Zusätzlich kann nach einem bestimmten Personenmerkmal eingegrenzt werden. Es ist möglich Adresszeilen für jede Personen-ID in Kurzform anzuzeigen.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → OP-Kontoauszüge → OP-Liste Fremdwährungen</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>von Personen-ID</dt>
<dd>Beginnend bei Personen-ID, ?=tiefste mögliche Personen-ID</dd>
<dt>bis Personen-ID</dt>
<dd>Einschliesslich bis Personen-ID, ?=höchstmögliche Personen-ID</dd>
<dt>von Datum</dt>
<dd>Beginnend bei Datum</dd>
<dt>bis Datum</dt>
<dd>Einschliesslich bis Datum</dd>
<dt>Adresse anzeigen</dt>
<dd>ja/nein (zeigt Adresse in Kurzform)</dd>
<dt>nur OP mit Whg</dt>
<dd>Eingabe der <a class="link" href="ft.refdata.whg.html" title="Währung">Währung</a></dd>
<dt>nur offene Buch.</dt>
<dd>OP mit dem Saldo 0 ignorieren?: ja/nein</dd>
<dt>nur mit Merkmal</dt>
<dd>nur OP verarbeiten, die angegebenes Merkmal enthalten</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Adressnr</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>FaktNr</td>
<td>Fakturanummer</td>
</tr>
<tr>
<td>ValDat</td>
<td>Valuta Datum</td>
</tr>
<tr>
<td>T</td>
<td>Buchungstyp</td>
</tr>
<tr>
<td>Soll (Fremdwährung)</td>
<td>Betrag im Soll</td>
</tr>
<tr>
<td>Soll (CHF)</td>
<td>Gegenwert der Fremdwährung umgerechnet mit entsprechendem Kurs in CHF</td>
</tr>
<tr>
<td>Haben (Fremdwährung)</td>
<td>Betrag im Haben</td>
</tr>
<tr>
<td>Haben (CHF)</td>
<td>Gegenwert der Fremdwährung umgerechnet mit entsprechendem Kurs in CHF</td>
</tr>
<tr>
<td>Saldo (Fremdwährung)</td>
<td>Saldo für jeden OP</td>
</tr>
<tr>
<td>Saldo (CHF)</td>
<td>Gegenwert der Fremdwährung umgerechnet mit entsprechendem Kurs in CHF</td>
</tr>
<tr>
<td>Total</td>
<td>Summe pro Adresse jeder Spalte, und am Schluss die Summe jeder Spalte über alle Adressen</td>
</tr>
</tbody>
</table>
<p>Outputbeispiel ohne Adressdetails</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                          03.10.2003 11:06:36 ers  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                            OP-Liste Fremdwährungen</span>
<span class="line">                 von Personen-ID:     10'476 bis:     10'476</span>
<span class="line">                 von Datum.......: 01.01.2003 bis: 03.10.2003</span>
<span class="line"></span>
<span class="line">                 Adresse anzeigen: nein</span>
<span class="line">                 nur OP mit Whg..: EUR</span>
<span class="line">                 nur offene Buch.: ja</span>
<span class="line">                 nur mit Merkmal.:</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">Adressnr  FaktNr ValDat   T       Soll EUR      Soll CHF     Haben EUR     Haben CHF   Saldo EUR   Saldo CHF</span>
<span class="line">-------- ------- -------- -- ------------- ------------- ------------- ------------- ----------- -----------</span>
<span class="line">   10476 2602427 14.07.03 A         103.45        206.90                                  103.45      206.90</span>
<span class="line">       .       . 22.07.03 Z                                      75.00        117.20      -75.00     -117.20</span>
<span class="line">                             ------------- ------------- ------------- ------------- ----------- -----------</span>
<span class="line">                                    103.45        206.90         75.00        117.20       28.45       89.70 TOTAL</span>
<span class="line"></span>
<span class="line">                             ------------- ------------- ------------- ------------- ----------- -----------</span>
<span class="line">                                    103.45        206.90         75.00        117.20       28.45       89.70 TOTAL</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Outputbeispiel mit Adressdetails</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                          03.10.2003 11:31:53 ers  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                            OP-Liste Fremdwährungen</span>
<span class="line">                 von Personen-ID:     10'476 bis:     10'476</span>
<span class="line">                 von Datum.......: 01.01.2003 bis: 03.10.2003</span>
<span class="line"></span>
<span class="line">                 Adresse anzeigen: ja</span>
<span class="line">                 nur OP mit Whg..: EUR</span>
<span class="line">                 nur offene Buch.: ja</span>
<span class="line">                 nur mit Merkmal.:</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                              Adresse (Kurzform)</span>
<span class="line"> Nr: 10476    Hans Muster                    Status: --K-   a-</span>
<span class="line">              Bahnhofstrasse 1               Geb.J.:</span>
<span class="line">              8001 Zürich</span>
<span class="line"></span>
<span class="line">Adressnr  FaktNr ValDat   T       Soll EUR      Soll CHF     Haben EUR     Haben CHF   Saldo EUR   Saldo CHF</span>
<span class="line">-------- ------- -------- -- ------------- ------------- ------------- ------------- ----------- -----------</span>
<span class="line">   10476 2602427 14.07.03 A         103.45        206.90                                  103.45      206.90</span>
<span class="line">       .       . 22.07.03 Z                                      75.00        117.20      -75.00     -117.20</span>
<span class="line">                             ------------- ------------- ------------- ------------- ----------- -----------</span>
<span class="line">                                    103.45        206.90         75.00        117.20       28.45       89.70 TOTAL</span>
<span class="line"></span>
<span class="line">                             ------------- ------------- ------------- ------------- ----------- -----------</span>
<span class="line">                                    103.45        206.90         75.00        117.20       28.45       89.70 TOTAL</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Der Kunde 10'476 hat uns einen Auftrag erteilt am 14.7.2003 im Wert von 103.45 EUR, in Landeswährung mit entsprechrendem Umrechnungskurs ist dies 206.90 CHF. Am 22.7.2003 wurde 75.00 EUR einbezahlt, in Landeswährung mit entsprechendem Umrechnungskurs ist dies 117.20 CHF. Das Debitorenkonto weist einen offenen Saldo in Fremdwährung von 28.45 EUR und in Landeswährung von 89.70 CHF aus. Die unterste Zeile zeigt das Total jeder Spalte über alle Adressen.</p>
<p>Zur Info: die Saldis sowie auch die Ereignisse werden in funtrade immer in der Landeswährung CHF angezeigt.</p>
</div></template>


